<template>
  <div class="element-input element-checkbox">
    <div class="label">{{ label }}</div>
    <ul>
      <li :class="{
        on: isMultiple
          ? ( value.indexOf( item.value ) >= 0 )
          : value }" v-for="item in items" @click="selectItem( item.value )">{{ item.label }}</li>
    </ul>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "type" ],
  computed: {
    isMultiple(){
      return this.items && this.items.length > 1;
    },
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created(){
    this.$watch( "isMultiple", isMultiple => {
      if( isMultiple && !Array.isArray( this.value ) ){
        this.$emit( "input", []);
      };
    }, { immediate: true });
  },
  methods: {
    selectItem( value ){
      if( value === '없음' ){
        if( this.isMultiple ){
          if( this.value.indexOf( value ) >= 0 ){
            this.$emit( "input", this.value.filter( o => o != value ) );
          }else{
            var temp = [];
            temp = temp.concat( [ value ]);
            this.$emit( "input", temp );
          };
        }
      }
      else{
        if( this.isMultiple ){
          if( this.value.indexOf( value ) >= 0 ){
            this.$emit( "input", this.value.filter( o => o != value ) );
          }else{
            var temp = this.value;
            if(temp && temp[0] == '없음'){
              temp = [];
            }
            temp = temp.concat( [ value ] );

            this.$emit( "input", temp );
          };
        }else{
          if( this.value ){
            this.$emit( "input", false );
          }else{
            this.$emit( "input", true );
          };
        }
      }
    }
  }
}
</script>
